import { useCallback, useState } from 'react';
import type { JSX } from 'react';
import RevealConfirmDialog from '../RevealConfirmDialog';
import type { UseMultiplayerReturn } from '../../hooks/useMultiplayer';

/**
 * «Показать игрокам…» of a journal entry found by the search: the journal's own reveal confirmation, then the same
 * journal:reveal the journal sends. Nothing goes out before «Показать».
 */
export function useRevealAsk(send: UseMultiplayerReturn['send']): {
  readonly ask: (entry: { readonly id: string; readonly name: string }) => void;
  readonly dialog: JSX.Element;
} {
  const [asking, setAsking] = useState<{ readonly id: string; readonly name: string } | null>(null);
  const ask = useCallback((entry: { readonly id: string; readonly name: string }): void => setAsking({ id: entry.id, name: entry.name }), []);
  const dialog = (
    <RevealConfirmDialog
      open={asking !== null}
      onOpenChange={(open): void => {
        if (!open) setAsking(null);
      }}
      entryName={asking?.name ?? ''}
      onConfirm={(): void => {
        if (asking !== null) send({ type: 'journal:reveal', entryId: asking.id });
        setAsking(null);
      }}
    />
  );
  return { ask, dialog };
}
